<pbc-filter [config]="config" [filter]="tourStati.filter$ | async" (filterChange)="tourStati.filter$.next($event)"></pbc-filter>
